<template>
  <se-popup classes="sm:w-[357px]" :show-close="false">
    <div class="flex flex-col justify-center items-center py-24 text-center">
      <div class="w-[56px] h-[56px] rounded-full bg-error-10 text-error-100 inline-flex justify-center items-center">
        <se-icon name="x" :size="26"/>
      </div>
      <h1 class="text-h-m mt-32 font-bold">Do you want to end this session?</h1>
      <p class="text-b-s max-w-[308px] mt-16">
        Your dialog will be closed. You can access session history anytime in the Dashboard or Sessions.
      </p>
      <div class="flex flex-col w-full gap-16 mt-32">
        <se-button class="w-full !ml-0" @click="emits('close')" type="tertiary" >
          No, I want to continue
        </se-button>
        <se-button @click="closeChat" class="w-full !ml-0" type="error">
          Yes, I want to end session
        </se-button>
      </div>
    </div>
  </se-popup>
</template>

<script setup lang="ts">

import SePopup from "@/src/shared/ui-kit/popup/Popup.vue";
import SeButton from "@/src/shared/ui-kit/button/Button.vue";
import SeIcon from "@/src/shared/ui-kit/icon/Icon.vue";

const emits = defineEmits(['close', 'endChat']);

const closeChat = () => {
  emits('close');
  emits('endChat');
}

</script>

<script lang="ts">
export default {
  name: 'SeEndChatConfirmationPopup',
};
</script>

<style scoped lang="scss">

</style>